/**
 * Function for cutting off a string at a given length (value).
 * If the string is longer then set value it gets ... appended.
 */
export function cutOffString(string: string, value: number) {
  const slicedString =
    string.charAt(value) === ' '
      ? string.slice(0, value - 1)
      : string.slice(0, value);
  if (string.length > value) {
    return `${slicedString}...`;
  }
  return slicedString;
}
